import { Somar, InputSomar } from '../../common/types/Somar'
import axios from '@/plugins/axios'
import GenericService from '@/shareds/GenericService'
import { Potencia } from 'common/types/Potencia'
import { Loja } from 'common/types/Loja'

export const PATH_SOMAR = '/somar'

class SomarService extends GenericService<Somar, InputSomar> {

	constructor() {
		super(PATH_SOMAR)
	}

	async getPotencias(id: string) {
		try {
			const result = await axios.get<Potencia[]>(`${PATH_SOMAR}/${id}/potencias`)
			return result.data
		} catch (error) {
			throw error
		}
	}

	async getLojas(id: string) {
		try {
			const result = await axios.get<Loja[]>(`${PATH_SOMAR}/${id}/lojas`)
			return result.data
		} catch (error) {
			throw error
		}
	}

}

export default new SomarService()
